.paper {
  display: flex;
  color: inherit;
}

.content {
  font-size: var(--tuna-typography-fontSize-xs);
  display: flex;
  align-items: center;
  padding-left: 8px;
  padding-right: 8px;
}
